module.exports = __webpack_public_path__ + "static/melt-e95604edf97a2b9ccc6f1ebd12175dca.mp4";